<style></style>

<template>
  <div>
    <div class="as-datatable">
      <b-table
        class="text-center"
        bordered
        striped
        hover
        small
        :busy="!isBusy"
        :items="orders"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        v-if="orders.length > 0"
      >
        <template v-slot:cell(amount)="row">
          <p class="text-center">{{ orderAmount(row.item.products) }} грн.</p>
        </template>
        <template v-slot:cell(date)="row">
          <p class="text-center">{{ formDate(row) }}</p>
        </template>
        <template v-slot:cell(status)="row">
          <p class="text-center">{{ typeStatus(row.item.status) }}</p>
        </template>
        <template v-slot:cell(actions)="row">
          <div class="btn-actions text-center">
            <button @click="toggleEdit(row)" class="btn btn-primary btn-sm">
              <font-awesome-icon
                v-if="!row.detailsShowing"
                class="as-icon"
                :icon="['fas', 'eye']"
              />
              <font-awesome-icon
                v-else
                class="as-icon"
                :icon="['far', 'eye-slash']"
              />
            </button>
          </div>
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <table class="table table-striped table-item">
              <thead>
                <tr>
                  <th>Код товара</th>
                  <th>Картинка</th>
                  <th>Название</th>
                  <th>Бренд</th>
                  <th>Кол-во</th>
                  <th>Цена</th>
                  <th>Действия</th>
                </tr>
              </thead>
              <tr v-for="(item, index) in row.item.products" :key="index">
                <td>es{{ item.exposhoes_id }}</td>
                <td>
                  <img
                    style="width:100px;height:auto;"
                    :src="item.images[0]"
                    alt
                  />
                </td>
                <td>{{ item.name[locale] }}</td>
                <td>{{ item.trademark }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ itemAmount(item.price, item.quantity) }} грн.</td>
                <td></td>
              </tr>
            </table>
          </b-card>
        </template>
      </b-table>
      <b-row v-if="orders.length > 0">
        <b-col md="6" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="orders.length"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
      <p class="text-danger text-center" v-else>Заказы отсутствуют...</p>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  data() {
    return {
      locale: this.$route.params.locale,
      changeCat: "0",
      filter: "0",
      currentPage: 1,
      perPage: 5,
      isBusy: true,
      orders: [],
      fields: [
        {
          key: "id",
          label: "№",
          sortable: false
        },
        {
          key: "user_id",
          label: "Заказчик",
          sortable: false
        },
        {
          key: "amount",
          label: "Сумма заказа",
          sortable: false
        },
        {
          key: "date",
          label: "Дата",
          sortable: false
        },
        {
          key: "status",
          label: "Статус",
          sortable: false
        },
        {
          key: "actions",
          label: "Действия",
          sortable: false
        }
      ]
    };
  },
  created() {
    this.getPost();
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    }
  },
  methods: {
    async getPost() {
      let orders = await Axios.get("/.netlify/functions/orders-get");
      for (let i = 0; i < orders.data.length; i++) {
        orders.data[i].data.id = orders.data[i].ref["@ref"].id;
        orders.data[i].data.ts = orders.data[i].ts;
        this.orders.push(orders.data[i].data);
      }
    },
    toggleEdit(row) {
      row.toggleDetails(true);
    },
    itemAmount(price, qt) {
      return parseInt(price) * parseInt(qt);
    },
    orderAmount(products) {
      let amount = 0;
      for (let i = 0; i < products.length; i++) {
        amount += parseInt(products[i].price) * parseInt(products[i].quantity);
      }
      return amount;
    },
    formDate(row) {
      let date = timeConverter(row.item.ts);
      return date;
    },
    typeStatus(status) {
      let st = null;
      switch (status) {
        case 1:
          st = "Новый";
          break;
        case 2:
          st = "В обработке";
          break;
        case 3:
          st = "Выполнен";
          break;
        case 4:
          st = "Удален";
          break;
        default:
          st = "";
          break;
      }
      return st;
    }
  }
};

function timeConverter(UNIX_timestamp) {
  let a = new Date(UNIX_timestamp / 1000);
  let months = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь"
  ];
  let year = a.getFullYear();
  let month = months[a.getMonth()];
  let date = a.getDate();
  let hour = a.getHours();
  let min = a.getMinutes();
  let sec = a.getSeconds();
  let time =
    date + " " + month + " " + year + " " + hour + ":" + min + ":" + sec;
  return time;
}
</script>
